export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:9000';
export const MaxCartAmountPerItem: number = parseInt(process.env.NEXT_PUBLIC_MAX_CART_AMOUNT_PER_ITEM || '10', 10);
